import {
  Box,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
} from "@chakra-ui/react";
import { Ref } from "react";

const PloyPopover = ({
  type = "click",
  isLazy = true,
  button,
  children,
  onClose,
  onOpen,
  isOpen,
  ref,
  closeOnBlur,
}: {
  type?: "click" | "hover";
  isLazy?: boolean;
  button: React.ReactNode;
  isOpen?: boolean;
  children: any;
  ref?: Ref<HTMLElement>;
  onClose?: () => any;
  onOpen?: () => any;
  closeOnBlur?: boolean;
}) => {
  return (
    <Popover
      trigger={type}
      isLazy={isLazy}
      closeOnBlur={closeOnBlur}
      onClose={onClose}
      onOpen={onOpen}
      isOpen={isOpen}
    >
      <PopoverTrigger>{button}</PopoverTrigger>
      <Portal containerRef={ref as any}>
        <Box
          sx={{
            "& .chakra-popover__popper": {
              zIndex: "popover",
            },
          }}
          zIndex={9999999}
        >
          <PopoverContent p={0} zIndex={99999999999} w="full">
            <PopoverArrow />
            <PopoverBody p={0}>{children}</PopoverBody>
          </PopoverContent>
        </Box>
      </Portal>
    </Popover>
  );
};

export default PloyPopover;
